module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABOAgMAAADzxMiOAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEWRYyM2HwEAAAB2k7hiAAAAAWJLR0QCZgt8ZAAAAAlwSFlzAAALEgAACxIB0t1+/AAAADBJREFUOMtjYEACoQEMmIC2gqyhWKTpJjiYwAAE/mAC9Pf+CA9wEBiI3Dca7CMvBACWaBttEkXpOAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/sand.png
// module id = 460
// module chunks = 114276838955818